import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import "./App.css";
import Categories from "./Pages/Categories";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Categories />} />
        <Route path="/category/:categoryId" element={<Home />} />
        {/* <Route path="/category" element={<Home />} /> */}
      </Routes>
    </Router>
  );
};

export default App;
